let flkty = null;
let listenersAttached = false;
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    document.addEventListener('cart:updated', function (event) {
      this.updateUpsellItems('true');
    }.bind(this));
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    this.updateUpsellItems(true)
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    this.updateUpsellItems('true');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));      
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  updateUpsellItems(status) {
    var thiss = this;
    setTimeout(function(){
      fetch(`/cart?view=get-upsell-items`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        
        const upsellProductDrawer = document.querySelector('.upsell-product-drawer');
        const upsellProductCarousel = document.querySelector('.upsell-product-drawer .upsell-carousel1');
        
        if (!upsellProductDrawer || !upsellProductCarousel) {
          console.warn('Required elements not found');
          return;
        }
    
        let upsellExist = true;
        if (upsellProductCarousel.innerHTML.trim() !== "" || upsellProductCarousel.childNodes.length > 0) {
          upsellExist = false;
        }
        var items = doc.querySelectorAll('.upsell_item');
        if (!items) {
          console.warn('No upsell items found');
        } else {
           const cartDrawerForm = document.getElementById('CartDrawer');
           if (cartDrawerForm) {
              cartDrawerForm.setAttribute('data-available-upsell', items.length);
          }
          // var totalUpsellFound = document.querySelectorAll('.upsell-item-slide').length;
          // var upsellProductDrawer = document.querySelector('.upsell-product-drawer');
          // if (upsellProductDrawer) {
          //     upsellProductDrawer.setAttribute('data-upsell-count', totalUpsellFound);
          // }
        }
        if (status) {
          const isEmpty = document.querySelector('#CartDrawer.is-empty');
          
          if (isEmpty) {
            if (flkty) {
              try {
                flkty.destroy();
                flkty = null;
              } catch (error) {
                console.warn('Error destroying Flickity:', error);
              }
            }
            // upsellProductCarousel.innerHTML = '';
            return;
          }
    
          // Safely destroy existing Flickity instance if it exists
          if (flkty) {
            try {
              flkty.destroy();
              flkty = null;
            } catch (error) {
              console.warn('Error destroying Flickity:', error);
            }
          }
    
          // Update content
          upsellProductCarousel.innerHTML = data;
          thiss.upsell_add_to_cart();
          thiss.getSectionsToRender();
    
          // Initialize new Flickity instance
          const announceSelector = document.querySelector('.upsell-carousel1');
          
          if (announceSelector && announceSelector.textContent.trim().length > 0) {
            try {
              // Small timeout to ensure DOM is ready
                flkty = new Flickity(announceSelector, {
                  cellAlign: 'center',
                  wrapAround: true,
                  prevNextButtons: false,
                  pageDots: false,
                  contain: true,
                  groupCells: 1
                });
    
                 if (!listenersAttached) {
                  document.querySelector('.flickity-prev-next-button.previous').addEventListener('click', () => {
                    flkty.previous();
                  });
                  
                  document.querySelector('.flickity-prev-next-button.next').addEventListener('click', () => {
                    flkty.next();
                  });
                 }
                listenersAttached = true;
    
              
            } catch (error) {
              console.error('Error initializing Flickity:', error);
            }
          }
        }
        },1000)
     
      .catch(error => {
        console.error('Error fetching upsell items:', error);
      });
    });
  }
  
  upsell_add_to_cart(){
    var thiss = this;
    const addToCartButtons = document.querySelectorAll('.add-to-cart.upsell-button');
    addToCartButtons.forEach(button => {
      button.addEventListener('click', function(event) {
        event.preventDefault(); 
        console.log("CLICK");
        const optionsContainer = button.closest('.options');
        if (optionsContainer) {
          const selectValue = optionsContainer.querySelector('select.product-single__variants')?.value;
          const variantId = selectValue;
          const quantity = 1;
          button.classList.add('btn--loading');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: quantity }]
            })
          })
          .then(response => response.json())
          .then(data => {
            button.classList.remove('btn--loading');
            // thiss.updateUpsellItems('true');
            document.dispatchEvent(
                new CustomEvent('cart:build', {
                    bubbles: true
                })
            );
          })
          .catch(error => {
            console.error('Error adding item:', error);
          });
        }
      });
    });
  }

  


}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}


customElements.define('cart-drawer-items', CartDrawerItems);
